var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFedex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 22.06",
    width: 72,
    height: 22.06,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff5900}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "polygon10",
    className: "cls-1",
    d: "M59.95 7.77l2.98 3.28 2.87-3.28h6.12l-5.99 6.73L72 21.28h-6.37l-2.95-3.3-2.92 3.3h-6.15l6.01-6.75-6.01-6.76h6.34z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "polygon12",
    className: "cls-1",
    d: "M53.61 7.77v4.57H46.8v4.19h6.81v4.75H41.79V0h11.82v4.74H46.8v3.03h6.81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M36.81 0v8.71h-.05A5.07 5.07 0 0032.67 7a6.9 6.9 0 00-6.61 5.17 7.11 7.11 0 00-7.31-5.23A7.45 7.45 0 0012 10.56V7.77H5.65v-3h6.92V0H0v21.28h5.65v-8.94h5.64a8.33 8.33 0 00-.26 2.1A7.44 7.44 0 0018.75 22a7.28 7.28 0 007.31-4.83h-4.85a2.42 2.42 0 01-2.46 1.22 2.91 2.91 0 01-2.83-2.9h9.87a7.17 7.17 0 006.94 6.57 4.83 4.83 0 004-2.15h.05v1.37h5V0zM16.08 12.4a2.73 2.73 0 012.67-2.24 2.6 2.6 0 012.7 2.24zM33.79 18c-1.84 0-3-1.71-3-3.5s1-3.74 3-3.74 2.88 1.83 2.88 3.74-.87 3.5-2.88 3.5z",
    fill: "#2a007c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFedex);
export default __webpack_public_path__ + "static/media/fedex.3cc782e114f4e84c31b1cd48ce2e5d55.svg";
export { ForwardRef as ReactComponent };